import LoadingStatusPage from "./LoadingStatus";

export default LoadingStatusPage;
